// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"6e5e16e3","622":"0cfd6c85"}[chunkId] + ".chunk.css";
};